import React from 'react'
import { useStore, observer } from '@/hooks/storeHooks'
import st from './index.scss'
import cn from 'classnames'

/**
 * title: 弹框标题
 * titleIcon: 标题icon
 * showCloseIcon：是否展示关闭弹框
 * content：文本内容
 * closeBtnText：关闭按钮内容（传入false不展示，传入文本正常展示）
 * ConfirmBtnText：确认按钮内容（传入false不展示，传入文本正常展示）
 * closeDialog: 关闭回调
 * cancelDialog: 取消方法
 * dialogConfirm：确认回调
 * disabledConfirm: 禁用确定按钮
 * showTrue ： 如果关闭按钮是操作按钮的话，样式和确认按钮一样
 */
export default observer(function Dialog(
    {
        title,
        titleIcon,
        showCloseIcon,
        content,
        closeBtnText = '取消',
        ConfirmBtnText = '确定',
        closeDialog,
        cancelDialog,
        dialogConfirm,
        disabledConfirm = false,
        ConfirmBtnColor,
        showTrue = false
    },
    porps
) {
    const { isZhumavip } = useStore()

    return (
        <div
            className={cn({
                [st['zhumaStyle']]: isZhumavip(),
                [st['zhongheStyle']]: !isZhumavip()
            })}
        >
            <div className={st['dialog']}>
                <div className={st['dialog_box']}>
                    <div className={st['dialog_title']}>
                        <div className={st['refundPopUpTitleCon']}>
                            {titleIcon ? <img src={titleIcon} alt="" /> : ''}
                            <span>{title}</span>
                        </div>

                        {
                            // showCloseIcon不展示关闭icon
                            showCloseIcon  ? (
                                <img
                                    className={st['close_img']}
                                    onClick={() => {
                                        closeDialog && closeDialog()
                                    }}
                                    src="https://osscdn.zhongheschool.com/mallP2_2022_6_16/pc/createOrder/close.png"
                                    alt=""
                                />
                            ) : (
                                null
                            )
                        }
                    </div>
                    <div className={st['dialog_contnet']}>
                        <div>{content}</div>
                    </div>
                    <div className={st['dialog_footer']}>
                        <div className={cn({[st['dialog_btn']]:true,[st['button-one']]:!closeBtnText || !ConfirmBtnText})}>
                            {closeBtnText ? (
                                <button
                                    className={cn({[st['dialog_btn_close']]:true,[st['confirm_btn']]:showTrue})}
                                    onClick={() => {
                                        cancelDialog ? cancelDialog() : closeDialog()
                                    }}
                                >
                                    {closeBtnText}
                                </button>
                            ) : (
                                ''
                            )}
                            {ConfirmBtnText ? (
                                <button
                                    style={{background: ConfirmBtnColor}}
                                    className={cn({
                                        [st['confirm_btn']]: true,
                                        [st['disabled']]: disabledConfirm,
                                    })}
                                    onClick={() => {
                                        if(disabledConfirm) return
                                        dialogConfirm && dialogConfirm()
                                    }}
                                >
                                    {ConfirmBtnText}
                                </button>
                            ) : (
                                ''
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
})
